import Alpine from 'alpinejs';

require('./bootstrap');
require('./ckeditor.js');
require('./numeric-input.js');
require('./compare-notification.js');
if (isFrontEnd()) {
  require('smartbanner.js/dist/smartbanner.min.css');
  const smartbanner = require('smartbanner.js')
}

function isFrontEnd() {
  return false;//document.body.classList.contains('custom_smartbanner');
}

require('./global.js');

// Intl-tel-input
require('./packages/intl-tel-input');

// Custom range input
require('./components/range-input');

// Common js file
require('./common.js');

require('./alpinejs')
require('./alpinejs_search_page')
require('./alpinejs_select2')
require('./alpinejs_newLaunch')
require('./alpinejs_plan_signup')
require('./addonForm')
require('./price-format')
Alpine.start();
if ($('#my-form').length) {
  require('./edit-project')
}
if ($('#pre-project-image-form').length) {
  require('./create-update-pre-project')
}

if ($('#banner-management-images-form').length) {
  require('./banner-management-images')
}

if(window.location.pathname.startsWith('/ae/search')){
  require('./bannerSticky')
}